import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';

const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL;

const ANALYTICS_STORAGE_KEY = "analytics_data";

// Current active event
let currentEvent = null;

// Start duration updater only once
let durationInterval = null;

// Track event start times
let eventStartTimes = {};


// START DURATION TRACKER
const startDurationTracker = () => {

  // Prevent multiple intervals
  if (durationInterval) return;

  durationInterval = setInterval(() => {

    // No active event
    if (!currentEvent) return;

    // Get analytics data
    const existingData = localStorage.getItem(
      ANALYTICS_STORAGE_KEY
    );

    if (!existingData) return;

    const analyticsData = JSON.parse(existingData);

    // Find current active event
    const activeEvent =
      analyticsData.events.find(
        (event) =>
          event.event_name === currentEvent
      );

    // Calculate real elapsed time automatically
    if (activeEvent && eventStartTimes[currentEvent]) {
      const currentTime = Date.now();
      const elapsedSeconds = Math.floor((currentTime - eventStartTimes[currentEvent]) / 1000);
      
      // Update duration with real elapsed time
      activeEvent.duration = elapsedSeconds;

      // Save updated data
      localStorage.setItem(
        ANALYTICS_STORAGE_KEY,
        JSON.stringify(analyticsData)
      );

      // console.log(
      //   `${currentEvent} duration updated: ${elapsedSeconds} seconds`
      // );
    }

  }, 5000); // Every 5 sec (update frequency, not increment)
};

const syncAnalyticsToDB = async () => {
  console.log("syncAnalyticsToDB CALLED");

  try {

    const analyticsData =
      localStorage.getItem(
        ANALYTICS_STORAGE_KEY
      );

    
    if (!analyticsData) {
      console.log("No analytics data found in localStorage");
      return;
    }

    const parsedData = JSON.parse(analyticsData);
    console.log("Raw analytics data from localStorage:", parsedData);
    
    // Transform to match backend UserAnalyticsRequest model
    const backendFormat = {
      session_id: parsedData.sessionId,
      user_id: parsedData.user_id,
      events: parsedData.events || []
    };

    console.log("Transformed data for backend:", backendFormat);
    console.log("API URL:", `${API_BASE_URL}/user-analytics-data`);

    const response = await axios.post(
      `${API_BASE_URL}/user-analytics-data`,
      backendFormat
    );
   
    // console.log(
    //   "Analytics synced to DB successfully",
    //   response.data
    // );

  } catch (error) {

    console.error(
      "Analytics sync failed",
      error
    );
    
    if (error.response) {
      console.error("Backend error response:", error.response.data);
      console.error("Status:", error.response.status);
      console.error("Headers:", error.response.headers);
    } else if (error.request) {
      console.error("No response received:", error.request);
    } else {
      console.error("Request setup error:", error.message);
    }
  }
};


setInterval(() => {

  syncAnalyticsToDB();

}, 1800000 ); //  1800000




// TRACK CTA

export const trackCTA = async (
  eventName,
  user,
  page = ''
) => {

  try {

    let analyticsData;

    // Create new session on page_view
    if (eventName === "page_view") {

      localStorage.removeItem(
        ANALYTICS_STORAGE_KEY
      );

      analyticsData = {
        sessionId: Date.now(),
        user_id: user?.id,
        events: []
      };

    } else {

      const existingData = localStorage.getItem(
        ANALYTICS_STORAGE_KEY
      );

      analyticsData = existingData
        ? JSON.parse(existingData)
        : {
            sessionId: Date.now(),
            user_id: user?.id,
            events: []
          };
    }

    // Safety check
    if (!analyticsData.events) {
      analyticsData.events = [];
    }

    // Check if event already exists
    let existingEvent =
      analyticsData.events.find(
        (event) =>
          event.event_name === eventName
      );

    if (!existingEvent) {
      existingEvent = {
        event_name: eventName,
        duration: 0,
        date: new Date().toISOString()
      };

      analyticsData.events.push(existingEvent);
    }

    // ALWAYS update start time
    eventStartTimes[eventName] = Date.now();
    
    // Save analytics
    localStorage.setItem(
      ANALYTICS_STORAGE_KEY,
      JSON.stringify(analyticsData)
    );

    // Set active event
    currentEvent = eventName;

    // Start tracker
    startDurationTracker();

    // 🔥 SEND CTA TO BACKEND DB
try {

  await axios.post(
    `${API_BASE_URL}/user-cta`,
    {
      account_id: user?.account_id || 1,
      user_id: user?.id,
      event: eventName,
      page
    }
  );

  console.log("CTA stored in DB");

} catch (apiError) {

  console.error(
    "Failed to store CTA in DB:",
    apiError
  );
}


    console.log(
      "CTA tracked:",
      eventName
    );

    console.log(
      "Current Analytics Data:",
      analyticsData
    );

    return analyticsData;

  } catch (error) {

    console.error(
      "Error tracking CTA:",
      error
    );

    return null;
  }
};


// PAGE VIEW TRACKING
export const usePageTracking = () => {

  const location = useLocation();
  const { user } = useAuth();
   useEffect(() => {
    const analyticsData = localStorage.getItem("analytics_data");

    if (analyticsData) {
      syncAnalyticsToDB();
    }
  }, []);
  

  // useEffect(() => {

  //   const alreadyTracked =
  //     sessionStorage.getItem(
  //       "page_view_tracked"
  //     );

  //   // Fire only once per session
  //   if (user?.id && !alreadyTracked) {

  //     trackCTA(
  //       "page_view",
  //       user,
  //       window.location.pathname
  //     );

  //     sessionStorage.setItem(
  //       "page_view_tracked",
  //       "true"
  //     );
  useEffect(() => {
  const alreadyTracked =
    sessionStorage.getItem(
      "page_view_tracked"
    );
  
  const analyticsDataExists = !!localStorage.getItem("analytics_data");
  
  // Create page_view if user exists AND either:
  // 1. Not already tracked, OR
  // 2. Already tracked but no analytics data exists (stale sessionStorage)
  if (user?.id && (!alreadyTracked || !analyticsDataExists)) {
    
    // Clear stale sessionStorage if analytics data doesn't exist
    if (alreadyTracked && !analyticsDataExists) {
      sessionStorage.removeItem("page_view_tracked");
    }
    
    trackCTA(
      "page_view",
      user,
      window.location.pathname
    );

    sessionStorage.setItem(
      "page_view_tracked",
      "true"
    );
  }

  // Reactivate homepage tracking
  if (location.pathname === "/home") {
    currentEvent = "page_view";
  }

}, [location, user]);
};
